{
  "salon-search-form-advance-dialog": {
    "buttons": {
      "cancel": "Hủy",
      "save": "Lưu"
    },
    "text": {
      "title": "Chọn lọc nâng cao",
      "kilometer": "km",
      "only-salon-with-discount": "Chỉ giảm giá",
      "only-salon-with-discount-description": "Chỉ hiển thị salon có dịch vụ giảm giá",
      "radius": "Bán kính",
      "radius-description": "Tìm kiếm các cửa tiệm trong bán kính bao xa",
      "sort-by": "Sắp xếp theo",
      "sort-by-distance": "Khoảng cách",
      "sort-by-distance-description": "Salon gần địa điểm mong muốn nhất sẽ được hiển thị trước",
      "sort-by-rating": "Đánh giá",
      "sort-by-rating-description": "Salon có đánh giá tốt nhất sẽ được hiển thị trước"
    }
  }
}
